const metaData = {
	'rulling-number': {
		en: {
			'2': {
				title: 'Numerology 2: The main number 2 for mediators',
				description:
					'The Numerology number 2 represents luck possessing sharp intuition. How special is this main number 2, find out now!'
			},
			'3': {
				title: 'Numerology 3: The main number 3 of the creative inspiration',
				description:
					'The Numerology number 3 represents the viewpoint of sharp thinking, thinking about reason. Discover the main meaning 3 in personality and career!'
			},
			'4': {
				title: 'Numerology 4: The main number 4 for actual people, principles',
				description:
					'The Numerology number 4 representing the actual viewpoint, they often focus on material values. The owner number 4 has other outstanding advantages, find out now!'
			},
			'5': {
				title: 'Numerology 5: The main number 5 of freedom, likes to explore',
				description:
					"The Numerology number 5 represents freedom and courage. The person with the dominant 5 is a lover of adventure, no binding. Let's explore now!"
			},
			'6': {
				title: 'Numerology 6: The main number 6 represents the rich affectionate',
				description:
					"The Numerology number 5 shows that you live emotionally, tolerant and caring for your family and community. Let's explore these dominant number 6 mysteries!"
			},
			'7': {
				title: 'Numerology 7: The main number 7 of intuition and knowledge',
				description:
					'The Numerology number 7 said that you are smart, hard -working, capable of persuading others, but business is not strength. Learn more advantages of the main number 7'
			},
			'8': {
				title: 'Numerology 8: The main number 8 of power, wealth',
				description:
					'The Numerology number 8 shows that you are a person with a confident, independent personality, which will become a leader that is trusted by many people. Discover the main advantages 8 right away!'
			},
			'9': {
				title: 'Numerology 9: The main number 9 of ambition, responsibility and faith',
				description:
					"The Numerology number 9 represents people with a high sense of responsibility, many ambitions. Let's explore the character of the main number 9!"
			},
			'10': {
				title: 'Numerology 10: The main number 10 of flexible, easy to adapt',
				description:
					'The Numerology number 10 highlights the adaptation and flexibility in all cases. With an easy-to-change personality, what is the dominant number 10?'
			},
			'11': {
				title: 'Numerology 11: The main number 11 is more emotional and sincere',
				description:
					'The Numerology number 11 shows that you are a person with sharp and easy -to -emotional intuition. Discover the highlights of this main number 11!'
			},
			'22': {
				title: 'Numerology 22: The main number 22 of genius',
				description:
					'The Numerology number 22 shows that you are one of the rare people with a very special number of masters. What is the secret of the dominant number 22 of genius? Watch now!'
			}
		},
		vi: {
			'2': {
				title: 'Thần số học số 2: Con số chủ đạo 2 dành cho người hòa giải',
				description:
					'Thần số học số 2 đại diện cho sự may mắn sở hữu năng lực trực giác nhạy bén. Số chủ đạo 2 này đặc biệt như thế nào, tìm hiểu ngay nhé!'
			},
			'3': {
				title: 'Thần số học số 3: Con số chủ đạo 3 của người truyền cảm hứng sáng tạo',
				description:
					'Thần số học số 3 đại diện quan điểm tư duy nhạy bén, suy nghĩ thiên về lý trí. Khám phá ý nghĩa số chủ đạo 3 về tính cách, sự  nghiệp nhé!'
			},
			'4': {
				title: 'Thần số học số 4: Con số chủ đạo 4 cho người thực tế, nguyên tắc',
				description:
					'Thần số học số 4 đại diện quan điểm thực tế, họ thường chú trọng vào giá trị vật chất. Người sở hữu số 4 có những ưu điểm nổi trội khác, tìm hiểu ngay nhé!'
			},
			'5': {
				title: 'Thần số học số 5: Con số chủ đạo 5 của sự tự do, thích khám phá',
				description:
					'Thần số học số 5 đại diện cho sự tự do, can đảm. Người có con số 5 chủ đạo là người yêu thích sự phiêu lưu, không ràng buộc. Cùng khám phá ngay nhé!'
			},
			'6': {
				title: 'Thần số học số 6: Con số chủ đạo 6 đại diện cho người giàu tình cảm',
				description:
					'Thần số học số 6 cho thấy bạn sống tình cảm, bao dung và quan tâm đến gia đình, cộng đồng. Cùng khám phá những bí ẩn số 6 chủ đạo này nhé!'
			},
			'7': {
				title: 'Thần số học số 7: Con số chủ đạo 7 của trực giác và tri thức',
				description:
					'Thần số học số 7 cho biết bạn thông minh, chịu khó, có khả năng thuyết phục người khác, tuy nhiên kinh doanh không phải là thế mạnh. Tìm hiểu thêm những ưu điểm của số chủ đạo 7'
			},
			'8': {
				title: 'Thần số học số 8: Con số chủ đạo 8 của quyền lực, giàu sang',
				description:
					'Thần số học số 8 cho thấy bạn là người có tính cách tự tin, độc lập, sẽ trở thành lãnh đạo được nhiều người tin tưởng. Khám phá những ưu điểm số chủ đạo 8 ngay nhé! '
			},
			'9': {
				title: 'Thần số học số 9: Con số chủ đạo 9 của hoài bão, trách nhiệm và đức tin',
				description:
					'Thần số học số 9 đại diện những người có tinh thần trách nhiệm cao, nhiều ước mơ hoài bão. Cùng nhau khám phá tính cách của số chủ đạo 9 nhé!'
			},
			'10': {
				title: 'Thần số học số 10: Con số chủ đạo 10 của người linh hoạt, dễ thích nghi',
				description:
					'Thần số học số 10 làm nổi bật tính thích nghi và linh hoạt ở mọi trường hợp. Với tính cách dễ thay đổi thì người mang số chủ đạo 10 sẽ có những ưu-nhược điểm gì?'
			},
			'11': {
				title: 'Thần số học số 11: Con số chủ đạo 11 thiên về cảm xúc và chân thành',
				description:
					'Thần số học số 11 cho thấy bạn là người có trực giác nhạy bén và dễ cảm xúc. Khám phá những điểm nổi bật của số chủ đạo 11 này nhé!'
			},
			'22': {
				title: 'Thần số học số 22: Con số chủ đạo 22 của thiên tài',
				description:
					'Thần số học số 22 cho thấy bạn là một trong những người hiếm có mang trong mình con số Master vô cùng đặc biệt. Bí mật của số chủ đạo 22 của thiên tài là gì? Xem ngay!'
			}
		}
	}
}

export default metaData
